export default "__VITE_ASSET__BS4JA59A__"